<template>
	<iframe
		v-if="iframeSrc"
		class="angular-frame"
		:src="iframeSrc"
		title="Angular page"
	></iframe>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useRoute } from "vue-router"
import { authStore } from "@/store/login"
import { loadSession } from "@/composables/useSession"

const route = useRoute()
const auth = authStore()

const ANGULAR_URL = process.env.VUE_APP_ANGULAR_URL || ""

const iframeSrc = computed(() => {
	const angularPath = String((route.meta as Record<string, unknown>).angularPath ?? "")
	console.log('angularPath=', angularPath)
	console.log('process.env.VUE_APP_ANGULAR_URL=', process.env.VUE_APP_ANGULAR_URL)
	if (!angularPath || !ANGULAR_URL) return ""

	const session = loadSession()
	const token = auth.jwtToken ?? session?.jwtToken ?? ""
	const sessionKey = auth.sessionKey ?? session?.sessionKey ?? ""
	const userId = auth.currentUserId ?? session?.id ?? ""

	const params = new URLSearchParams({
		token: String(token),
		sessionKey: String(sessionKey),
		userId: String(userId),
		embedded: "true",
	})
	return `${ANGULAR_URL}/${angularPath}?${params.toString()}`
})
</script>

<style scoped>
.angular-frame {
	width: 100%;
	height: 100%;
	border: none;
	display: block;
}
</style>
